import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';

@Component({
    selector: 'checkout-account-status-additional',
    templateUrl: './checkout-account-status-additional.component.html',
    standalone: true,
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutAccountStatusAdditionalComponent extends UiComponent {}
